<template>
  <div class="page">
    <div class="page--content">
      WebCallPage
    </div>
  </div>
</template>

<script>
import { hasRole } from 'utils/functions'

export default {
  name: 'WebCallPage',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    }
  }
}
</script>

<style lang="scss" >
@media (min-width: 961px) {

  .route--webcall {
    padding-top: 0;
  }
}
</style>
